// extracted by mini-css-extract-plugin
export default {"statusBox":"noPerson_statusBox__qsRij","noPersonText":"noPerson_noPersonText__99uG-","retryStyle":"noPerson_retryStyle__-oCt5"};